/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AvailabilityModeEnum = {
    OnlineOnly: 'ONLINE_ONLY',
    OnSiteOnly: 'ON_SITE_ONLY',
    OnSiteAndOnline: 'ON_SITE_AND_ONLINE'
} as const;
export type AvailabilityModeEnum = typeof AvailabilityModeEnum[keyof typeof AvailabilityModeEnum];

